import { styled } from '@mui/material';

import { Skeleton } from '@app-velocity/ui';

const StyledPage = styled('div')(({ theme }) => ({
  padding: theme.spacing(3),
}));

export const ConfigureScenarioPageSkeleton = () => (
  <StyledPage>
    <Skeleton width={120} height={14} />
    <Skeleton width={300} height={29} />
    <Skeleton width={150} height={20} />
    <Skeleton height={94} />
    <Skeleton height={136} />
  </StyledPage>
);
